import type { Category } from './type';
export const WORKERS_FOR_SELECT_PATH = '/v2/workers-for-select' as const;
export const INDIVIDUAL_WORKERS_FOR_SELECT_PATH = '/v2/self-service/workers-for-select' as const;
export const workersForSelect = {
  all: [WORKERS_FOR_SELECT_PATH] as const,
  workers: (searchText: string, category?: Category, isIndividual?: boolean, excludeNotHaveWorkerEmail?: boolean) => [...(isIndividual ? [INDIVIDUAL_WORKERS_FOR_SELECT_PATH] : workersForSelect.all), {
    searchText,
    category,
    excludeNotHaveWorkerEmail
  }] as const
} as const;